import { useProfile } from '@/hooks/useProfile';

/**
 * Hook pour vérifier si l'utilisateur connecté est administrateur
 *
 * @returns {Object} - Objet contenant:
 *   - isAdmin: boolean - true si l'utilisateur est admin
 *   - isLoading: boolean - true pendant le chargement du profil
 *   - error: Error | null - erreur éventuelle lors du chargement
 *   - profile: Profile | null - profil complet de l'utilisateur
 */
export function useIsAdmin() {
  const { data: profile, isLoading, error } = useProfile();

  return {
    isAdmin: profile?.is_admin === true,
    isLoading,
    error,
    profile,
  };
}
